export default __webpack_public_path__ + "static/423-682be1526086c3da358f12c2aedb8eba.gif";